// import img1 from '../assets/images/user.svg';
import { Link, NavLink } from 'react-router-dom';
import { useGetSettingQuery } from '../../../Redux/Apis/siteApi';
import img2 from '../assets/images/cart.svg';

function Header() {
	const {data : { name, menu }} = useGetSettingQuery()

    return ( 
        <nav className="custom-navbar navbar navbar navbar-expand-md navbar-dark" arial-label="Furni navigation bar">

			<div className="container">
				<Link className="navbar-brand" to="/">{name}<span>.</span></Link>

				<button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarsFurni" aria-controls="navbarsFurni" aria-expanded="false" aria-label="Toggle navigation">
					<span className="navbar-toggler-icon"></span>
				</button>

				<div className="collapse navbar-collapse" id="navbarsFurni">
					<ul className="custom-navbar-nav navbar-nav ms-auto mb-2 mb-md-0">
						{
							menu && menu.map((row,index) => 
								<li key={index}><NavLink className="nav-link" to={row.value} end caseSensitive>{row.key}</NavLink></li>
							)
						}
					</ul>

					<ul className="custom-navbar-cta navbar-nav mb-2 mb-md-0 ms-5">
						{/* <li><a className="nav-link" href="!#"><img src={img1} alt=""/></a></li> */}
						<li><Link className="nav-link" to="/shop"><img src={img2} alt=""/></Link></li>
					</ul>
				</div>
			</div>
				
		</nav>
    )
}

export default Header;